module.exports = __webpack_public_path__ + "static/media/8-skjnte.53f01d7c.mp3";